module.exports = "https://bin.bnbstatic.com/_next/static/images/BNBadoption-0485316e8d845dd958146cbf25c329a5.svg";